import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "width": "12", "height": "12", "viewBox": "0 0 12 12", "fill": "none" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M1.86287 4.735C1.74876 4.61488 1.75363 4.42499 1.87375 4.31087L2.52625 3.691C2.64637 3.57688 2.83626 3.58175 2.95037 3.70188L5.99999 6.91199L9.04942 3.70189C9.16354 3.58177 9.35342 3.5769 9.47355 3.69101L10.1261 4.31087C10.2462 4.42498 10.2511 4.61487 10.1369 4.73499L6.36251 8.70828C6.16539 8.91579 5.83463 8.9158 5.6375 8.70829L1.86287 4.735Z", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const ArrowStrokeSelectDownIcon = __component__.exports;
export {
  ArrowStrokeSelectDownIcon as default
};
